import user from './user'
import security from './security'
import order from './order'
import driver from './driver'
import general from './general'
import map from './map'

export default {
  name: 'Setting',
  path: 'setting',
  meta: {
    label: 'settings',
    auth: 'setting'
  },
  component: {
    name: 'Setting',
    render(c) {
      return c('router-view')
    }
  },
  children: [user, driver, order, security, general, map]
}
